<template>
  <div>
    <div class="flex center-flex-x center-flex-y" style="background-color:#424242;padding:10px;">
      <div class="input-box" style="width: 250px;margin-bottom: 0;margin-right: 12px;height:33px;">
        <input id="searchTermInput" style="height: 100%;" v-model="searchPhrase" />
      </div>
      <button class="hidden-button" @click="search()">Search Stock Images</button>
    </div>
    <div v-if="images && (images.mmCatalogue || images.gettyCreative || images.gettyEditorial || images.unsplash)">
      <md-tabs @md-changed="changeImagesTab">
        <template slot="md-tab" slot-scope="{ tab }">
          {{ tab.label }} <i class="badge" v-if="tab.data.badge">{{ tab.data.badge }}</i>
        </template>
        <md-tab v-if="images.mmCatalogue" id="mmCatalogue" md-label="MM Catalogue" :md-template-data="{ badge: images.mmCatalogue.length }"></md-tab>
        <md-tab id="upload" md-label="Upload"></md-tab>
        <md-tab v-if="images.gettyEditorial" id="gettyEditorial" md-label="Getty Editorial" :md-template-data="{ badge: images.gettyEditorial.length }"></md-tab>
        <md-tab v-if="images.gettyCreative" id="gettyCreative" md-label="Getty Creative" :md-template-data="{ badge: images.gettyCreative.length }"></md-tab>
        <md-tab v-if="images.unsplash" id="unsplash" md-label="Unsplash" :md-template-data="{ badge: images.unsplash.length }"></md-tab>
      </md-tabs>
      <div>
        <md-content v-if="'upload' == currentTab">
          <div class="flex" style="justify-content: space-around;">
            <image-upload @file-array="processFileDataEdit">UPLOAD AND EDIT</image-upload>
            <image-upload @file-array="processFileDataCrop">UPLOAD AND CROP</image-upload>
          </div>

          <div class="input-box" style="width: 400px;height: 33px;margin: 10px auto;display: block;max-width:80%;">
            <input id="searchTermInput" style="height: 100%;" v-model="associatedText" placeholder="Enter text to help find it later..." />
          </div>

        </md-content>
      </div>
      <div v-for="(imageList,listKey) in images" :key="listKey">
        <md-content v-if="listKey == currentTab">
          <div class="grid">
            <div class="grid-sizer"></div>
              <div class="grid-item" v-for="(item,key) in imageList" :key="key">
                <div v-if="item.type == 'getty'">
                  <img :src="item.preview" />
                  <div class="hidden-buttons">
                      <button class="hidden-button" @click="buyThenEmit({nextStep: 'second'})">BUY AND EDIT</button>
                      <button class="hidden-button" @click="buyThenEmit({nextStep: 'third'})">BUY AND CROP</button>
                  </div>
                </div>
                <div v-if="item.type == 'catalogue'">
                  <img :src="item.url" />
                  <div class="hidden-buttons">
                      <button class="hidden-button" @click="$emit('process-file-url',{url: item.url, nextStep: 'second', catalogueImage: true})">EDIT IMAGE</button>
                      <button class="hidden-button" @click="$emit('process-file-url',{url: item.url, nextStep: 'third', catalogueImage: true})">CROP IMAGE</button>
                  </div>
                </div>
                <div v-if="item.type == 'unsplash'">
                  <img  :src="item.url" />
                  <div class="hidden-buttons">
                      <button class="hidden-button" @click="$emit('done', {url: item.url, searchText: item.photo.description || '' + ' ' + item.photo.alt_description || '' + ' ' + item.photo.categories.join(',')})">SELECT</button>
                  </div>
                </div>
              </div>
          </div>
        </md-content>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import ImageUpload from "./imageUpload";
import config from "../../../config.json";

export default {
  name: "modal",
  props: [],
  components: {
    ImageUpload
  },
  data: function() {
    return {
        images: [],
        currentTab: "gettyEditorial",
        searchString: "",
        searchPhrase: "",
        currentMasonry: null,
        associatedText: ""
    };
  },
  watch: {
    phraseimages: function(val) {
      this.images = val;
    },
    images: function(val) {
      $(".grid").imagesLoaded(() => {
        console.log("imagesLoaded images changed");
        if(this.currentMasonry) {
          this.currentMasonry.masonry('destroy');
          this.currentMasonry = false;
        }
        Vue.nextTick(() => {
          this.currentMasonry = $('.grid').masonry({
          // set itemSelector so .grid-sizer is not used in layout
              itemSelector: '.grid-item',
              // use element for option
              columnWidth: '.grid-sizer',
              percentPosition: true,
              gutter: 10,
              transitionDuration: '0.2s'
          });
        })
      });
    },
    searchPhrase: function(query) {
      this.alogoliaSearch(query);
    }
  },
  mounted: function() {
    var client = algoliasearch(
        "U5GL740LVM",
        "ee79df2ed46df0e29f0a0e05d9d2466f"
    );
    this.algolia = client.initIndex("images");
    this.alogoliaSearch("");
  },
  destroyed: function() {
    if(this.currentMasonry) this.currentMasonry.masonry('destroy');
  },
    methods: {
      processFileDataEdit: function(data) {
        this.$emit("process-file-array", {bytes: data.bytes, associatedText: this.associatedText, nextStep: "second"});
      },
      processFileDataCrop: function(data) {
        this.$emit("process-file-array", {bytes: data.bytes, associatedText: this.associatedText, nextStep: "third"});
      },
      alogoliaSearch: function(query) {
        console.log(query);
        if(!query) {
            query = "";
        }
        this.algolia
            .search({
              query
            })
            .then(responses => {
              this.images = {
                mmCatalogue: [],
                gettyEditorial: [],
                gettyCreative: [],
                unsplash: []
              }
              var searchResults = [];
              console.log(responses);
              responses.hits.forEach(hit => {
                console.log(hit.url);
                searchResults.push({
                    url: hit.url,
                    searchString: hit.searchString,
                    type: "catalogue"
                });
              });

              // To avoid DOM redraws repeatedly
              // Is this needed? Is Vue smart enough to not redraw when lots of pushes happen?
              this.images.mmCatalogue = searchResults;
        });
      },
      changeImagesTab: function(tab) {
        this.currentTab = tab;
        Vue.nextTick(() => {
          if(this.currentMasonry) {
            this.currentMasonry.masonry('destroy');
            this.currentMasonry = false;
          }
          this.currentMasonry = $('.grid').masonry({
          // set itemSelector so .grid-sizer is not used in layout
              itemSelector: '.grid-item',
              // use element for option
              columnWidth: '.grid-sizer',
              percentPosition: true,
              gutter: 10,
              transitionDuration: '0.2s'
          })
          $(".grid").imagesLoaded(() => {
            if(this.currentMasonry) {
              this.currentMasonry.masonry('layout');
              setTimeout(() => {
                this.currentMasonry.masonry('layout');
              },1000);
              setTimeout(() => {
                this.currentMasonry.masonry('layout');
              },2500);
              setTimeout(() => {
                this.currentMasonry.masonry('layout');
              },5000);
            } else {
              this.currentMasonry = $('.grid').masonry({
              // set itemSelector so .grid-sizer is not used in layout
                  itemSelector: '.grid-item',
                  // use element for option
                  columnWidth: '.grid-sizer',
                  percentPosition: true,
                  gutter: 10,
                  transitionDuration: '0.2s'
              })
            }
          });
        });
      },
      buyThenEmit: function() {
        var download = window.confirm("This will use up a download from the total Getty download limit, are you sure you'd like to continue?");
        if(download) {
        axios.get(config.apiAdmin + "/buyGettyImage?id=" + photo.id)
          .then((response) => {
            // handle success
            console.log(response);
            this.$emit("done",{url: response.data.url, searchText: ""});
          });
        }
      },
      buyImage: function(photo) {
        var download = window.confirm("This will use up a download from the total Getty download limit, are you sure you'd like to continue?");
        if(download) {
        axios.get(config.apiAdmin + "/buyGettyImage?id=" + photo.id)
          .then((response) => {
            // handle success
            console.log(response);
            this.$emit("done",{url: response.data.url, searchText: ""});
          });
        }
        console.log(photo);
      },
      search: function() {
        var term = document.getElementById("searchTermInput").value;
        axios.get(config.apiAdmin + "/getImages?phrase=" + (term || "a"))
          .then((response) => {
            // handle success
            console.log(response);
            for(var key in response.data) {
              Vue.set(this.images, key, response.data[key]);
              
            }              
          });
      }
    }
}
</script>


<style>
  .badge {
    width: 19px;
    height: 19px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: absolute;
    top: 2px;
    right: 2px;
    background: #cecece;
    border-radius: 100%;
    color: #151414;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    padding-right: 1px;
    letter-spacing: -0.05em;
    font-family: 'Roboto Mono', monospace;
  }
.md-tabs-navigation .md-button-content {
    font-size: 12px;
}
/* fluid 5 columns */
.grid-sizer,
.grid-item { width: 20%; margin-bottom:10px; position:relative; }
/* 2 columns */
.grid-item--width2 { width: 40%;margin-bottom:10px; }
.grid-item img {
    width:100%;
    display:block;
}
.crop-button {
  text-align:center;
    display: block;
    width: 200px;
}
.hidden-buttons {
    display:none;
    position:absolute;
    left:0;
    right:0;
    bottom:0;
    top:0;
    background-color:rgba(0,0,0,0.4);
}
.hidden-buttons button {
    justify-self: center;
    width:120px;
    margin-bottom:10px;
}
.grid-item:hover .hidden-buttons {
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
}

.result em {
  background-color: #ccc;
  color: black;
}
</style>

<style scoped>
#image {
  max-width: 100%; /* This rule is very important, please do not ignore this! */
  max-height:calc(95vh - 175px);
}
.result {
  cursor: pointer;
  margin: 5px 0;
}
.result:hover {
  background-color: #eee;
}
.result.selectedItem {
  background-color: #8ebab5;
}

</style>


// WEBPACK FOOTER //
// imageSelect.vue?2c5fa5aa